import { render } from "./RegistrationOrderFormBlock.vue?vue&type=template&id=e7078220&scoped=true"
import script from "./RegistrationOrderFormBlock.vue?vue&type=script&lang=js"
export * from "./RegistrationOrderFormBlock.vue?vue&type=script&lang=js"

import "./RegistrationOrderFormBlock.vue?vue&type=style&index=0&id=e7078220&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7078220"]])

export default __exports__